import * as angular from 'angular';

import { WidgetBase } from '../models';
import { Helper } from '../../common';
import { AlarmsTableConfiguration } from './alarmsTable.configuration';
import { alarmsTableWidgetDefinition as definition } from '../../widgets/widgets.definition.index';

export class AlarmsTableWidget extends WidgetBase {
    baseType = definition.baseType;
    col = 0;
    configuration: AlarmsTableConfiguration;
    exportFormats = ['csv'];
    guid: string;
    hasExtendedProperties = true;
    highlights = definition.highlights;
    icon = definition.icon;
    isExportable = true;
    name = definition.title;
    row = 0;
    sizeX = 12;
    sizeY = 18;
    type = definition.type;
    
    exportToCsv: () => angular.IPromise<[]>;

    constructor() {
        super();
        this.guid = Helper.getGuid();
        this.configuration = new AlarmsTableConfiguration();
    }
}